var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { accountSummaryV2CacheKey } from "syf-api/api";
import { Stack } from "syf-component-library/ui/spacing";
import { Body } from "syf-component-library/ui/typography";
import links from "../../../../const/links";
import modalIds from "../../../../const/modalIds";
import { useConfig } from "../../../../hooks/useConfig";
import VantageLink from "../../../atoms/VantageLink";
import VantageTrans from "../../../atoms/VantageTrans";
import CreditInfluences from "../CreditInfluences";
import CreditTipCard from "../CreditTipCard";
import { ButtonWrapper, CreditButton, ExternalLink, StaticWrapper, } from "./subcomponents";
import UnenrollModalPopUp from "./UnenrollModal";
import UnenrollSuccessModalPopUp from "./UnenrollSuccessModal";
var CreditScoreStaticContent = function (_a) {
    var vantageEnrolledAccounts = _a.vantageEnrolledAccounts;
    var queryClient = useQueryClient();
    var assets = useConfig().hosts.assets;
    var creditScorePdf = "".concat(assets.origin, "/assets/vantage/credit-score-quick-guide.pdf");
    var _b = useState({
        successModal: {
            isOpen: false,
            containerId: "",
        },
        unenrollModal: {
            isOpen: false,
            containerId: "",
        },
    }), modals = _b[0], setModals = _b[1];
    var handleOpenModal = function (modalKey, containerId) {
        var _a;
        setModals(__assign(__assign({}, modals), (_a = {}, _a[modalKey] = {
            isOpen: true,
            containerId: containerId,
        }, _a)));
    };
    var handleCloseModal = function (modalKey) {
        var _a;
        setModals(__assign(__assign({}, modals), (_a = {}, _a[modalKey] = {
            isOpen: false,
            containerId: "",
        }, _a)));
    };
    var switchModalState = function () {
        setModals({
            successModal: {
                isOpen: true,
                containerId: modalIds.UNENROLL_SUCCESS_MODAL_ID,
            },
            unenrollModal: {
                isOpen: false,
                containerId: "",
            },
        });
    };
    var handleResetQueries = function () {
        vantageEnrolledAccounts.forEach(function (accountId) {
            queryClient.resetQueries({
                queryKey: accountSummaryV2CacheKey({
                    accountId: accountId,
                    accountIdType: "guid",
                }),
                exact: true,
            });
        });
    };
    return (_jsxs(StaticWrapper, __assign({ id: modalIds.UNENROLL_MODAL_ID }, { children: [_jsx(CreditInfluences, {}), _jsx(CreditTipCard, {}), _jsx(Body, { children: _jsx(VantageTrans, { i18nKey: "creditScorePage.disclaimers.thirdParty" }) }), _jsx(Stack, { size: "large" }), _jsx(VantageTrans, { i18nKey: "creditScorePage.disclaimers.transUnion", components: {
                    link1: _jsx(VantageLink, { to: links.ANNUAL_CREDIT_LINK, isExternal: true }),
                    link2: _jsx(VantageLink, { to: links.DISPUTE_LINK, isExternal: true }),
                } }), _jsx(Stack, { size: "large" }), _jsx(VantageTrans, { i18nKey: "creditScorePage.disclaimers.creditRepair" }), _jsx(Stack, { size: "xxlarge" }), _jsxs(ButtonWrapper, { children: [_jsx(CreditButton, __assign({ href: creditScorePdf, target: "_blank", "data-object": "link", "data-type": "credit score", "data-analytics": "clicktrackingevent", "data-reason": "learn more about improve score" }, { children: _jsx(VantageTrans, { i18nKey: "creditScorePage.links.learnMore" }) })), _jsx(Stack, { size: "large" }), _jsx(ExternalLink, __assign({ buttonType: "text", onClick: function () {
                            return handleOpenModal("unenrollModal", modalIds.UNENROLL_MODAL_ID);
                        }, "data-object": "link", "data-type": "credit score", "data-analytics": "clicktrackingevent", "data-reason": "unenroll your credit score" }, { children: _jsx(VantageTrans, { i18nKey: "creditScorePage.links.unenroll" }) }))] }), _jsx(UnenrollModalPopUp, { isOpen: modals.unenrollModal.isOpen, vantageEnrolledAccounts: vantageEnrolledAccounts, onClose: function () { return handleCloseModal("unenrollModal"); }, openSuccessModal: switchModalState }), _jsx(UnenrollSuccessModalPopUp, { isOpen: modals.successModal.isOpen, onClose: function () {
                    handleResetQueries();
                    handleCloseModal("successModal");
                } }), _jsx(Stack, { size: "xxlarge" })] })));
};
export default CreditScoreStaticContent;
